import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    role: "separator",
    "aria-orientation": "vertical",
    "aria-label": "Resize Atlas AI panel",
    tabindex: "0",
    class: _normalizeClass([
      'absolute top-0 left-0 h-full w-1.5 z-10 cursor-col-resize select-none',
      'group',
      _ctx.dragging ? 'bg-blue-500/40' : _ctx.isDark ? 'hover:bg-blue-500/30' : 'hover:bg-blue-500/20'
    ]),
    onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPointerDown && _ctx.onPointerDown(...args))),
    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
    onDblclick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDoubleClick && _ctx.onDoubleClick(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-0.5 h-8 rounded-full transition-colors',
        _ctx.dragging
          ? 'bg-blue-400'
          : _ctx.isDark
            ? 'bg-gray-600 group-hover:bg-blue-400'
            : 'bg-gray-400 group-hover:bg-blue-500'
      ])
    }, null, 2)
  ], 34))
}